import React from 'react';
import { Col, Row, Form } from 'react-bootstrap';
import { useLoad } from '../../collection/Hooks';
import { BsButton, BsCard, BsForm, BsFormControl, BsFormSelect } from '../../collection/bootstrap/BootstrapComponents';
import Loading from '../../collection/icons/Loading';
import { apiGet } from '../../utils/api';

/**
 * Filter for PrendasTable.
 * Props:
 * - onFilter(data): Función que se ejecuta cuando se debe actualizar la tabla, la función recibe los datos del formulario de filtro y debe devolver la tabla resultante.
 * - defaultValue: Valores por defecto del filtro.
 */
export default function PrendasFilter(props) {
    const { defaultValue, onFilter, ...otherProps } = props;

    const updateData = () => defaultValue;
    const saveData = async data => {
        if (!data.get("gruposTallas[]"))
            data.delete("gruposTallas[]");
        await onFilter(data);
    }

    return <BsForm
        onUpdate={updateData}
        onSave={saveData}>
        <PrendasFilterForm {...props} />
    </BsForm>;
}

function PrendasFilterForm(props) {
    const data = props.data;
    // listas entidades
    var [gruposTallasList] = useLoad(async () => await apiGet("prendas/gruposTallasList"));

    return gruposTallasList ? <>
        <style> {'.form-check-lg { transform: scale(1.4); }'} </style>
        <BsCard header="Filtro" className={props.className}>
            <>
                <Row className="gy-3 mb-3">
                    {/* Nombre */}
                    <Col md="6">
                        <BsFormControl
                            label="Nombre" name="nombre"
                            value={data.nombre} />
                    </Col>
                    {/* Grupos Tallas */}
                    <Col md="6">
                        <BsFormSelect
                            label="Grupos Tallas" name="gruposTallas[]"
                            value={data.grupoTallas} options={gruposTallasList}
                            isClearable isMulti />
                    </Col>
                </Row>
                <Row className="gy-3 mb-3">
                    <Col sm={4}>EPI</Col>
                    <Col sm={8}>
                        <Form.Check
                            name="epi" value="true"
                            defaultChecked={data.epi}
                            type="switch" id="epi" className="form-check-lg" />
                    </Col>
                </Row>
            </>
            <div className="d-flex justify-content-center gap-3 mt-3">
                <BsButton onClick={props.onSubmit}>Mostrar resultados</BsButton>
            </div>
        </BsCard>
    </> : <Loading/>
}
